<template>
  <BaseReminder class="flow-privacy-policy-reminder">
    {{ $t('contacts.privacy_policy.annotation') }}
    <a
      :href="policyUrl"
      target="_blank"
      class="flow-privacy-policy-reminder__link"
      @click="onPolicyClick"
    >
      {{ $t('contacts.privacy_policy.link') }}
    </a>
  </BaseReminder>
</template>

<script setup lang="ts">
  import { onMounted, ref } from 'vue'
  import { useRoute } from 'vue-router'
  import type { InboundFlowRoutes, OutboundFlowRoutes } from '@/shared/types/router.types'
  import BaseReminder from '@/shared/components/BaseReminder/BaseReminder.vue'
  import { useCommonStore } from '@/shared/store'
  import { useGoogleAnalytics } from '@/shared/composables'

  interface Props {
    place?: string
  }

  const props = defineProps<Props>()

  const commonStore = useCommonStore()
  const policyUrl = ref('')

  const route = useRoute()
  const gaService = useGoogleAnalytics()

  const onPolicyClick = () => {
    // TODO: перейти на useFlowSteps после появления возможности переиспользования composable
    gaService.sendClickPrivacyPolicy(
      route.name as InboundFlowRoutes | OutboundFlowRoutes,
      props.place
    )
  }

  onMounted(async () => {
    try {
      policyUrl.value = await commonStore.getPrivacyPolicyUrl()
    } catch (error) {
      console.error(error)
    }
  })
</script>

<style lang="scss">
  @import './FlowPrivacyPolicyReminder';
</style>
